var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._g(_vm._b({tag:"component"},'component',{tag: _vm.tag, mode: _vm.mode, appear: _vm.appear},false),{beforeEnter: _vm.beforeEnter, enter: _vm.enter, leave: _vm.leave}),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }